import type { ElectricalRuleHandle } from "building-types/handles/docEntityHandleTypes";
import {
  BuildingGenerationIssueType,
  type BuildingGenerationIssue,
} from "building-types/settings/buildingGenerationIssue";
import type { SettingsFragment } from "building-types/settings/settingsFragment";
import { SettingsType } from "building-types/settings/settingsType";
import type { Table } from "common/data/table";

export function collectElectricalSettingsGenerationIssues(docSettings: Table<SettingsFragment>) {
  const issues: BuildingGenerationIssue[] = [];
  const settingRuleIdDuplicates: { [ruleId: string]: ElectricalRuleHandle[] } = {};
  for (const settingId in docSettings) {
    const setting = docSettings[settingId];
    if (setting.type !== SettingsType.ELECTRICAL_SETTINGS) {
      continue;
    }
    const { rules } = setting;
    for (const ruleId in rules) {
      const electricalRuleHandle: ElectricalRuleHandle = {
        type: "ELECTRICAL_RULE",
        settingsHandle: { type: "SETTINGS", id: settingId },
        id: ruleId,
      };
      if (!settingRuleIdDuplicates[ruleId]) {
        settingRuleIdDuplicates[ruleId] = [electricalRuleHandle];
      } else {
        settingRuleIdDuplicates[ruleId].push(electricalRuleHandle);
      }
    }
  }

  for (const ruleId in settingRuleIdDuplicates) {
    const ruleIdDuplicates = settingRuleIdDuplicates[ruleId];
    const duplicateCount = ruleIdDuplicates.length;
    if (ruleIdDuplicates.length < 2) {
      continue;
    }
    issues.push({
      type: BuildingGenerationIssueType.ELECTRICAL_RULE_DUPLICATE_ID,
      handle: ruleIdDuplicates[duplicateCount - 1],
      unusedHandles: ruleIdDuplicates.slice(0, duplicateCount - 1),
    });
  }
  return issues;
}
